import React from 'react';
import { useTheme } from '../Theme/ThemeProvider';

const Footer = () => {
  const { theme, clientName } = useTheme();
  const isBlandford = theme === 'blandford';
  const isCoolmore = theme === 'coolmore';
  const isFramont = theme === 'framont';
  
  return (
    <footer className={`${
      isBlandford ? 'bg-[#2f2355] py-6' : 
      isCoolmore ? 'bg-[#000c40] py-6' : 
      isFramont ? 'bg-[#1E2A38] py-6' :
      'bg-gray-100 py-4'
    } text-center`}>
      <p className={`${
        isBlandford || isCoolmore ? 'text-white' : 
        isFramont ? 'text-[#FFD166]' : 
        'text-gray-600'
      }`}>
        {clientName} - Powered by <a 
          href="https://www.jhjwconsulting.com/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className={`${
            isBlandford ? 'text-[#ff7e00] hover:text-white' : 
            isCoolmore ? 'text-[#006d77] hover:text-white' : 
            isFramont ? 'text-white hover:text-[#FFD166]' :
            'text-primary'
          }`}
        >
          JHJW Consulting Ltd.
        </a>
      </p>
      {(isBlandford || isCoolmore || isFramont) && (
        <div className="mt-2 flex justify-center space-x-4">
          {/* <a href="#" className={`${
            isBlandford ? 'text-white hover:text-[#ff7e00]' :
            isCoolmore ? 'text-white hover:text-[#006d77]' :
            isFramont ? 'text-[#FFD166] hover:text-white' :
            ''
          }`}>Privacy Policy</a>
          <a href="#" className={`${
            isBlandford ? 'text-white hover:text-[#ff7e00]' :
            isCoolmore ? 'text-white hover:text-[#006d77]' :
            isFramont ? 'text-[#FFD166] hover:text-white' :
            ''
          }`}>Terms of Service</a>
          <a href="#" className={`${
            isBlandford ? 'text-white hover:text-[#ff7e00]' :
            isCoolmore ? 'text-white hover:text-[#006d77]' :
            isFramont ? 'text-[#FFD166] hover:text-white' :
            ''
          }`}>Contact</a> */}
        </div>
      )}
    </footer>
  );
};

export default Footer;